export function checkActiveProcess(dataset, processName) {
    if (dataset.runningTasks && dataset.runningTasks.length > 0) {
        for (let i = 0; i < dataset.runningTasks.length; i++) {
            if (dataset.runningTasks[i].performer === processName) {
                return dataset.runningTasks[i];
            }
        }
    }
    return null;
}